import { createContext, useContext, useState, useEffect } from "react";
import { getAuthMe } from "../../api/authApi"; // senin yazdığın getAuthMe
import { customerApi } from "../../utils/apiConfig";

// JWT'nin bitiş zamanı (ms); okunamazsa null
const tokenBitis = (t) => {
  try {
    const payload = JSON.parse(atob(t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return payload.exp ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
};

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => sessionStorage.getItem("token"));
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await getAuthMe();
        setUser(res.data.data);
        setPermissions(res.data.data.permissions || []);
      } catch (err) {
        console.error("auth/me çağrısı başarısız:", err);
        logout();
      } finally {
        setLoading(false); //  çağrı bitince loading false
      }
    };

    if (token) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, [token]);

  // Oturum düştüğünde (token süresi doldu / geçersiz, kullanıcı pasife alındı) girişe yönlendir:
  // kullanıcı bilgisi silinince korumalı sayfalar kendiliğinden /login'e gider.
  useEffect(() => {
    const oturumuKapat = () => {
      sessionStorage.removeItem("token");
      setToken(null);
      setUser(null);
      setPermissions([]);
    };
    // Bazı uçlar oturumla ilgisiz durumlarda da 401 dönüyor (ör. kamera oturumu); bu yüzden 401 gelince
    // oturumu doğrudan kapatmak yerine /authMe ile doğrula, o da reddederse kapat.
    let kontrolde = false;
    const oturumuDogrula = async () => {
      if (kontrolde) return;
      kontrolde = true;
      try {
        await getAuthMe();
      } catch (e) {
        const st = e?.response?.status;
        if (st === 401 || st === 404) oturumuKapat();
      } finally {
        kontrolde = false;
      }
    };
    const id = customerApi.interceptors.response.use(
      (res) => res,
      (error) => {
        const status = error?.response?.status;
        const kod = error?.response?.data?.errorCode;
        const authMe = String(error?.config?.url || "").endsWith("/authMe");
        // 401: token yok / geçersiz; 4003: kullanıcı bulunamadı ya da pasife alındı
        if (!authMe && (status === 401 || kod === 4003) && sessionStorage.getItem("token")) oturumuDogrula();
        return Promise.reject(error);
      }
    );
    // API çağrısı olmayan sayfalarda da süresi dolan token yakalansın
    const kontrol = () => {
      const t = sessionStorage.getItem("token");
      const bitis = t && tokenBitis(t);
      if (bitis && bitis <= Date.now()) oturumuKapat();
    };
    const timer = setInterval(kontrol, 30000);
    document.addEventListener("visibilitychange", kontrol);
    return () => {
      customerApi.interceptors.response.eject(id);
      clearInterval(timer);
      document.removeEventListener("visibilitychange", kontrol);
    };
  }, []);

  const login = (newToken) => {
    sessionStorage.setItem("token", newToken);
    setToken(newToken);
  };

  const logout = () => {
    sessionStorage.removeItem("token");
    setToken(null);
    setUser(null);
    setPermissions([]);
  };

  return (
    <AuthContext.Provider value={{ token, user, permissions, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};


export const useAuth = () => useContext(AuthContext);
